import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-back",
  "use": "icon-back-usage",
  "viewBox": "0 0 21 20",
  "content": "<symbol viewBox=\"0 0 21 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-back\">\r\n<path d=\"M7.36328 15.455L1.90874 10.0004L7.36328 4.5459\" stroke=\"#696974\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol